import styled from "styled-components";

export const CheckboxCircle = styled.div<{ checked: boolean }>`
  position: relative;
  width: 3.2rem;
  height: 3.2rem;
  border: ${(props) =>
    props.checked ? null : `2px solid ${props.theme.lightGrey}`};
  border-radius: 3.2rem;
  background: ${(props) =>
    props.checked ? props.theme.flashpicksBlue : props.theme.white};
  cursor: pointer;

  > img {
    position: absolute;
    top: 28%;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }
`;
